import SectionInputs from './sectionInputs.js';
export default SectionInputs;
